import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, Defs, Rect, G, ClipPath } from "react-native-svg";

export default function SharedIcon(props) {
  const { style, width = 40, height = 40, onPress = () => {} } = props;

  return (
    <TouchableOpacity style={[style]} onPress={onPress}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath="url(#clip0_shared)">
          <Path
            d="M16.3277 17.5625C17.0777 17.5625 17.6856 16.9749 17.6856 16.25C17.6856 15.5251 17.0777 14.9375 16.3277 14.9375C15.5778 14.9375 14.9698 15.5251 14.9698 16.25C14.9698 16.9749 15.5778 17.5625 16.3277 17.5625Z"
            fill="#ABADB3"
          />
          <Path
            d="M17.2977 22.4375V20C17.2977 19.4426 17.5286 18.9369 17.9018 18.5654C17.6773 18.4072 17.4021 18.3125 17.1037 18.3125H15.5519C14.8031 18.3125 14.194 18.9013 14.194 19.625V21.125C14.194 21.1961 14.2355 21.2609 14.3012 21.2928L14.9782 21.62L15.1643 24.1385C15.1716 24.2366 15.2562 24.3125 15.3579 24.3125H17.2977C17.3994 24.3125 17.4839 24.2366 17.4913 24.1383L17.5813 22.9199C17.4098 22.8204 17.2977 22.6392 17.2977 22.4375Z"
            fill="#ABADB3"
          />
          <Path
            d="M24.0871 17.5625C24.8371 17.5625 25.445 16.9749 25.445 16.25C25.445 15.5251 24.8371 14.9375 24.0871 14.9375C23.3372 14.9375 22.7292 15.5251 22.7292 16.25C22.7292 16.9749 23.3372 17.5625 24.0871 17.5625Z"
            fill="#ABADB3"
          />
          <Path
            d="M23.1173 22.4375V20C23.1173 19.4426 22.8864 18.9369 22.5132 18.5654C22.7376 18.4072 23.0129 18.3125 23.3112 18.3125H24.8631C25.6119 18.3125 26.221 18.9013 26.221 19.625V21.125C26.221 21.1961 26.1795 21.2609 26.1137 21.2928L25.4367 21.62L25.2507 24.1385C25.2433 24.2366 25.1587 24.3125 25.0571 24.3125H23.1173C23.0156 24.3125 22.931 24.2366 22.9237 24.1383L22.8336 22.9199C23.0051 22.8204 23.1173 22.6392 23.1173 22.4375Z"
            fill="#ABADB3"
          />
          <Path
            d="M20.9834 18.3125H19.4315C18.469 18.3125 17.6857 19.0696 17.6857 20V22.4375C17.6857 22.5269 17.7508 22.6038 17.8416 22.6213L18.6653 22.7804L18.85 25.6366C18.8564 25.7354 18.9411 25.8125 19.0436 25.8125H21.3714C21.4738 25.8125 21.5586 25.7354 21.565 25.6366L21.7496 22.7806L22.5733 22.6214C22.6641 22.6038 22.7293 22.5269 22.7293 22.4375V20C22.7293 19.0696 21.9459 18.3125 20.9834 18.3125Z"
            fill="#ABADB3"
          />
          <Path
            d="M20.2075 17.5625C21.1701 17.5625 21.9534 16.8054 21.9534 15.875C21.9534 14.9446 21.1701 14.1875 20.2075 14.1875C19.245 14.1875 18.4617 14.9446 18.4617 15.875C18.4617 16.8054 19.245 17.5625 20.2075 17.5625Z"
            fill="#ABADB3"
          />
        </G>
        <Defs>
          <ClipPath id="clip0_shared">
            <Rect
              width="12.415"
              height="12"
              fill="white"
              transform="translate(14 14)"
            />
          </ClipPath>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
